@if (bulkType === 'new') {
  <div class="am-flex-align gap-xxs bb-grey height-45">
    <span class="am-flex-center icon-arrow-left p-xs font-xl hover-active" title="Zurück zur Liste" (click)="closeCreate()"></span>
    <span class="font-m font-500">Gruppen-Chat erstellen</span>
  </div>
}

@if      (bulkType === 'list') { <bulk-messages-list (edit)="editHandler($event)" (create)="bulkType = 'new'"></bulk-messages-list> }
@else if (bulkType === 'new' ) { <bulk-messages-new [message]="message" (close)="closeCreate()"></bulk-messages-new>  }
